$(document).ready(() => {
	$('.datepicker').each(function () {
		$(this).datepicker({
			format: 'dd-mm-yyyy'
		});
	});
});